import { Button, notification } from 'antd';
import { ACUERDOS_PROXIMOS_KEY, AUTH_TOKEN } from 'constants/auth';
import { TIPOS_NOTIFICACIONES } from 'constants/demoData';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getAcuerdosProximos } from 'routes/acuerdos/api';
import useNotificaciones from './useNotificaciones';

const useNotificacionesSocket = (usuario) => {
  const { totales, setTotales } = useNotificaciones();
  const [messages, setMessages] = useState([]);
  const [api, contextHolder] = notification.useNotification();
  const location = useLocation();
  const currentPath = location.pathname;

  const handleSocketMessage = (event) => {
    try {
      const response = JSON.parse(event.data);

      if (response.status !== "success") return;

      const { type: eventType, notificacion } = response.data;

      console.log(response)

      switch (eventType) {
        case "auth":
          console.log("✅ Autenticado");
          break;
        case "notificacion":
          switch (notificacion?.notificaciones_tipos_id) {
            case TIPOS_NOTIFICACIONES.AUTORIZACION:
              setTotales(prev => ({
                ...prev,
                total_autorizaciones: prev.total_autorizaciones + 1,
              }));
              break;
            case TIPOS_NOTIFICACIONES.SOLICITUD:
              setTotales(prev => ({
                ...prev,
                total_solicitudes: prev.total_solicitudes + 1,
              }));
              break;
            default:
              console.warn("⚠️ Tipo de notificacion no reconocida:", notificacion?.notificaciones_tipos_id);
              break;
          }

          setMessages((prev) => {
            if (prev.some(msg => msg.id === notificacion.id)) return prev;
            return [notificacion, ...prev];
          });

          api.info({
            message: notificacion?.title,
            description: notificacion?.message,
            placement: 'bottomRight',
          })
          break;
        case "notificacion_leida":
          switch (notificacion?.notificaciones_tipos_id) {
            case TIPOS_NOTIFICACIONES.AUTORIZACION:
              setTotales(prev => ({
                ...prev,
                total_autorizaciones: Math.max(0, prev.total_autorizaciones - 1),
              }));
              break;
            case TIPOS_NOTIFICACIONES.SOLICITUD:
              setTotales(prev => ({
                ...prev,
                total_solicitudes: Math.max(0, prev.total_solicitudes - 1),
              }));
              break;
            default:
              console.warn("⚠️ Tipo de notificacion no reconocida:", notificacion?.notificaciones_tipos_id);
              break;
          }
          setMessages(prev =>
            prev.filter(msg => msg.id !== notificacion?.id)
          );
          break;
        default:
          console.warn("⚠️ Evento no reconocido:", eventType);
      }
    } catch (error) {
      console.error("❌ Error parseando mensaje:", error);
    }
  };

  useEffect(() => {
    // sacar este if
    if (false) {
      const socket = new WebSocket("ws://localhost:9006/api/public/iniciar-v3");
      const token = localStorage.getItem(AUTH_TOKEN);

      socket.onopen = () => {
        console.log("🔗 Conectado al WebSocket");
        socket.send(JSON.stringify({ type: "auth", token, usuario }));
      };

      socket.onmessage = handleSocketMessage;
      socket.onclose = (e) => console.log("🔌 Socket cerrado:", e.code, e.reason);
      socket.onerror = (e) => console.error("❌ Error en WebSocket: ", e);

      return () => socket.close();
    }/*  else {
      const ejecutarSiDentroDelHorario = () => {
        const ahora = new Date();
        const hora = ahora.getHours();
        if (hora >= 9 && hora < 17) {
          fetch();
        }
      };

      ejecutarSiDentroDelHorario();

      const interval = setInterval(() => {
        ejecutarSiDentroDelHorario();
      }, 10 * 60 * 1000);

      return () => clearInterval(interval);
    } */
  }, [usuario]);

  useEffect(() => {
    const fetchAcuerdosProximos = async () => {
      // ✅ Verificar ANTES de hacer el fetch si ya fue mostrado
      const yaFueMostrado = sessionStorage.getItem(ACUERDOS_PROXIMOS_KEY);
      if (yaFueMostrado) return;

      try {
        const resp = await getAcuerdosProximos("");
        const total = resp?.data?.totalDataSize || 0;

        if (total > 0 && currentPath !== "/acuerdos") {
          notification.warning({
            message: "Acuerdos próximos a vencer",
            description: `Tenés ${total} acuerdo${total > 1 ? "s" : ""} que vence${total > 1 ? "n" : ""} en los próximos 15 días.`,
            placement: "bottomRight",
            duration: 0,
            btn: (
              <Button
                type="primary"
                size="small"
                onClick={() => {
                  notification.destroy();
                  window.location.href = "/acuerdos";
                }}
              >
                Ver acuerdos
              </Button>
            ),
            onClose: () => {
              sessionStorage.setItem(ACUERDOS_PROXIMOS_KEY, "true");
            },
          });
        }
      } catch (e) {
        console.error("Error al verificar acuerdos próximos", e);
      }
    };

    fetchAcuerdosProximos();
  }, []);

  return {
    messages,
    totales,
    contextHolder,
  };
};

export default useNotificacionesSocket;
